import { useState } from "react";
import { Glasses, Scan, Headset } from "lucide-react";
import { xrStore } from "@/components/three/xrStore";
import { useStore } from "@/store/useStore";

export default function ARButton() {
  const arOk = useStore((s) => s.xrAR);
  const vrOk = useStore((s) => s.xrVR);
  const [msg, setMsg] = useState("");

  const enter = async (kind) => {
    try {
      await (kind === "vr" ? xrStore.enterVR() : xrStore.enterAR());
      setMsg("");
    } catch (e) {
      setMsg(`Couldn't start ${kind.toUpperCase()}. Open on a WebXR ${kind.toUpperCase()} device.`);
    }
  };

  const anyXR = arOk === true || vrOk === true;
  const resolved = arOk !== null && vrOk !== null;

  return (
    <div className="space-y-1.5">
      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={() => enter("ar")}
          disabled={arOk !== true}
          data-testid="enter-ar-button"
          className={`pill flex items-center justify-center gap-1.5 rounded-xl border py-2.5 text-xs font-semibold ${
            arOk !== true
              ? "cursor-not-allowed border-white/10 bg-white/[0.02] text-slate-500"
              : "border-[#d4af37]/60 bg-gradient-to-br from-[#e6c65a]/20 to-[#b8922b]/15 text-[#f3dd8f] hover:shadow-[0_0_20px_rgba(212,175,55,0.3)]"
          }`}
        >
          {arOk !== true ? <Scan className="h-4 w-4" /> : <Glasses className="h-4 w-4" />}
          Enter AR
        </button>
        <button
          onClick={() => enter("vr")}
          disabled={vrOk !== true}
          data-testid="enter-vr-button"
          className={`pill flex items-center justify-center gap-1.5 rounded-xl border py-2.5 text-xs font-semibold ${
            vrOk !== true
              ? "cursor-not-allowed border-white/10 bg-white/[0.02] text-slate-500"
              : "border-cyan-400/50 bg-gradient-to-br from-cyan-400/20 to-cyan-600/15 cyan-text hover:shadow-[0_0_20px_rgba(0,240,255,0.3)]"
          }`}
        >
          <Headset className="h-4 w-4" />
          Enter VR
        </button>
      </div>
      {anyXR ? (
        <p className="text-[0.72rem] leading-relaxed text-slate-500">
          Place the product in your room (AR) or step inside the showroom (VR). Use a VR controller
          to select the in-scene flashlight toggle or teleport points.
        </p>
      ) : (
        resolved && (
          <p className="text-[0.72rem] leading-relaxed text-slate-500" data-testid="ar-unsupported-note">
            Open this page on a WebXR-capable device (AR-ready phone or a VR headset) to enter
            immersive mode.
          </p>
        )
      )}
      {msg && <p className="text-[0.72rem] leading-relaxed text-rose-300">{msg}</p>}
    </div>
  );
}
